if (!customElements.get('missence-embla-carousel')) {
  customElements.define(
    'missence-embla-carousel',
    class MissenceEmblaCarousel extends HTMLElement {
      constructor() {
        super();
        this.handleDotClick = this.handleDotClick.bind(this);
        this.onSelect = this.onSelect.bind(this);
      }

      connectedCallback() {
        if (this.embla || !window.EmblaCarousel) return;

        this.viewport = this.querySelector('[data-embla-viewport]');
        this.dots = Array.from(this.querySelectorAll('[data-embla-dot]'));

        if (!this.viewport) return;

        const autoplayEnabled = this.dataset.autoplay === 'true';
        const autoplayDelay = Number(this.dataset.delay) || 5000;
        const shouldLoop = this.dataset.loop !== 'false';
        const plugins = [];

        if (autoplayEnabled && this.dots.length > 1 && window.EmblaCarouselAutoplay) {
          plugins.push(
            window.EmblaCarouselAutoplay({
              delay: autoplayDelay,
              stopOnInteraction: false,
              stopOnMouseEnter: true,
            })
          );
        }

        this.embla = window.EmblaCarousel(
          this.viewport,
          {
            align: 'start',
            containScroll: 'trimSnaps',
            dragFree: false,
            loop: shouldLoop,
          },
          plugins
        );

        this.embla.on('init', this.onSelect);
        this.embla.on('reInit', this.onSelect);
        this.embla.on('select', this.onSelect);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', this.handleDotClick);
        });

        this.onSelect();
      }

      disconnectedCallback() {
        if (!this.embla) return;

        this.dots.forEach((dot) => {
          dot.removeEventListener('click', this.handleDotClick);
        });

        this.embla.destroy();
        this.embla = null;
      }

      handleDotClick(event) {
        const button = event.currentTarget;
        const index = Number(button.dataset.index);

        if (Number.isNaN(index) || !this.embla) return;
        this.embla.scrollTo(index);
      }

      onSelect() {
        if (!this.embla) return;

        const selectedIndex = this.embla.selectedScrollSnap();

        this.dots.forEach((dot, index) => {
          const isActive = index === selectedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }
    }
  );
}
